import React from 'react';

import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { Formik, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { restValidationToForm } from '../utils/formUtils';
import { quitRegistration } from '../api/registrations';
import { nth } from '../utils/formatters';

interface Values {
  registration_id: number;
  ssn: string;
  resignation_reason: string;
}

interface Props {
  onClose: (created: boolean) => void;
  originalValues: any;
}
const DeleteRegisteredChildModal = ({ originalValues, onClose }: Props): React.ReactElement => {
  const { t } = useTranslation(['deleteRegisteredChildModal']);
  /* const [selectedDay, setSelectedDay] = useState<any>(); */

  const initialValues: Values = {
    registration_id: originalValues.registrations[0].registration_id,
    ssn: originalValues.ssn,
    resignation_reason: '',
  };

  /* useEffect(() => {
    const today = dayjs();

    if (today.date() > 20) {
      setSelectedDay(today.add(1, 'months').startOf('month').toDate());
    } else {
      setSelectedDay(today.toDate());
    }
  }, []); */

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={async (values: Values, { setSubmitting, setFieldError }: FormikHelpers<Values>) => {
          try {
            await quitRegistration(values);

            toast.success(t('studentDeletedSuccess'));
            onClose(true);
          } catch (e) {
            restValidationToForm({
              t,
              errorResponse: e.response,
              setFieldError,
              errorFieldMap: {
                name: 'name',
              },
            });
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ handleReset, handleSubmit, setStatus, values, setFieldValue }) => (
          <Modal show onHide={() => onClose(false)} backdrop="static" keyboard={false} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>{t('title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form
                onReset={handleReset}
                onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
                  setStatus('submitted');
                  handleSubmit(e);
                }}
              >
                <Form.Group controlId="name">
                  <Form.Label style={{ fontWeight: 'bold' }}>{t('confirmResignation')}</Form.Label> <br />
                  <Form.Label className="margin-bottom-0">
                    {originalValues.name} - {originalValues.school_name}
                  </Form.Label>
                  <Form.Text className="text-muted text-indent margin-top-0 margin-bottom-0">{values.ssn}</Form.Text>
                  {/* <Form.Label>{originalValues.school_name}</Form.Label> */}
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t('resignationReason')}</Form.Label>
                  <Form.Control type="text" onChange={(e) => setFieldValue('resignation_reason', e.currentTarget.value)} />
                </Form.Group>
                <Alert variant="info">
                  <FontAwesomeIcon icon={faInfoCircle} style={{ marginRight: '5px' }} />
                  {originalValues.resignation_cutoff === 0 && (
                    <>
                      <span>{t('resignationInformation2')}</span>
                    </>
                  )}
                  {originalValues.resignation_cutoff !== 0 && (
                    <>
                      <span>{t('resignationInformation', { day: originalValues.resignation_cutoff, nth: nth(originalValues.resignation_cutoff) })}</span>
                    </>
                  )}
                </Alert>
                {/* Geymi þetta incase það þurfi
                <Form.Group controlId="date">
                  <Form.Label>
                    {t('endOfRegistration')}
                    <span style={{ color: 'red' }}>*</span>
                  </Form.Label>
                  <div className="dateWrapper">
                    <DatePicker
                      style={{ display: 'inline', width: '100%' }}
                      value={selectedDay}
                      onDayChange={(day: Date) => {
                        console.log(day);
                        setFieldValue('dateTo', dayjs(day).format('DD.MM.YYYY'));
                        setSelectedDay(dayjs(day).toDate());
                      }}
                    />
                    <div className="calendarIcon">
                      <FontAwesomeIcon className="sidebarToggleIcon" icon={faCalendarAlt} style={{ display: 'inline' }} />
                    </div>
                  </div>
                </Form.Group> */}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="danger"
                type="submit"
                onClick={() => {
                  setStatus('submitted');
                  handleSubmit();
                }}
              >
                {t('submit')}
              </Button>
              <Button variant="secondary" onClick={() => onClose(false)}>
                {t('common:cancel')}
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>
    </>
  );
};

export default DeleteRegisteredChildModal;
